import { useMutation } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useLogout from './useLogout';
import { useNavigate } from 'react-router-dom';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export interface LoginRequestPayload {
  email: string;
  password: string;
}

function deleteAccount() {
  const requestURL = '/user/delete-account';

  return request(requestURL, {
    method: 'DELETE',
  });
}

export default function useDeleteAccount() {
  const logout = useLogout();
  const { notifyError } = useNotification();
  const navigate = useNavigate();
  const { t } = useTranslation(['userSettings']);

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: () => deleteAccount(),
    onSuccess: () =>
      logout().then(() => {
        navigate('/login');
        window.location.assign(window.location as any);
      }),
    onError: () => {
      notifyError({
        title: t('userSettings:messages.deleteAccountError'),
      });
    },
  });
  return { deleteAccount: mutateAsync, isLoading };
}
